import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages} from 'react-intl';

import {connect, ssr_wait} from '@stubhub/react-store-provider';

import SEOInternalLinks from '../react-seo-internal-links';

import controller from './controller';

import './index.scss';

const messages = defineMessages({
  venuePerformersTitle: {
    id: 'VenuePerformers.title',
    defaultMessage: 'Performers at {entityName}',
    description: 'View all performers at venue',
  },
});

class SEOVenuePerformers extends React.Component {
  @ssr_wait
  init() {
    const {loadPerformers} = this.props;

    return loadPerformers(this.props);
  }

  UNSAFE_componentWillMount() {
    const {venuePerformers} = this.props;
    if (!venuePerformers || venuePerformers.length === 0) {
      this.init();
    }
  }

  componentWillUnmount() {
    const {resetPerformers} = this.props;
    resetPerformers();
  }

  render() {
    const {venuePerformers = [], intl, entityId, entityName, entityType} = this.props;
    const title = intl.formatMessage(messages.venuePerformersTitle, {entityName});

    return venuePerformers.length > 0 ? (
      <div className="SEOVenuePerformers">
        <SEOInternalLinks
          className="CityPage__NearbyCities"
          entityType={entityType}
          entityId={entityId}
          seoLinks={venuePerformers}
          title={title}
        />
      </div>
    ) : null;
  }
}

SEOVenuePerformers.propTypes = {
  entityId: PropTypes.number,
  entityName: PropTypes.string,
  venuePerformers: PropTypes.array,
  entityType: PropTypes.string,
  resetPerformers: PropTypes.func.isRequired,
  loadPerformers: PropTypes.func.isRequired,

  /** The intl object */
  intl: PropTypes.object.isRequired,
};

export {SEOVenuePerformers};

export default injectIntl(connect(controller)(SEOVenuePerformers));
